import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1785336872227-a1e2b44c3cd2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/50 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-script text-5xl gold-text">Good People, Great Moments</p>
          <p className="text-[#C4C1B8] mt-4 max-w-md">
            Réservez les plus grands artistes pour vos événements d'exception.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <Logo size="text-3xl" />
          </div>
          <h1 className="font-serif text-4xl text-white mb-2">{title}</h1>
          <p className="text-[#A19E95] mb-8">{subtitle}</p>
          {children}
          <p className="text-center text-xs text-[#6E6B63] mt-8">
            <Link to="/" className="hover:text-[#C9A24B]">← Retour à l'accueil</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
